<template>
    <div class="dispensing-item-preview">
        <div class="action mb-2">
            <span>{{ t('patients::dispensing.form.title.schedule_restart') }}</span>
        </div>
        <v-form ref="form" v-model="form" :disabled="readOnlyRules" class="restart-form">
            <v-row>
                <v-col cols="5">
                    <b-date-picker-store
                        :label="t('patients::options.date')"
                        to-mutate="patients::dispensingForm.event_date"
                        :rules="validationRules.event_date"
                        mandatory
                        @change="setSelectedRestartPeriod"
                    >
                    </b-date-picker-store>
                </v-col>
                <v-col cols="7">
                    <b-select
                        to-mutate="patients::dispensingForm.schedule_restart_period"
                        :label="t('patients::dispensing.form.label.schedule_restart_period')"
                        :select-items="dispensingScheduleOptions"
                        :rules="validationRules.schedule_restart_period"
                        :readonly="true"
                    ></b-select>
                </v-col>
                <v-col cols="12">
                    <v-btn
                        color="primary"
                        small
                        rounded
                        outlined
                        :disabled="!form || readOnlyRules"
                        @click="restartSchedule"
                    >
                        {{ t('default::button.restart') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
export default {
    props: {
        readOnlyRules: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            form: false,
            validationRules: {
                schedule_restart_period: [(v) => !!v || t('users::validation.field.required')],
                event_date: [
                    (v) => !!v || t('users::validation.field.required'),
                    (v) => {
                        const treatmentBreakDate = moment(this.dispensing.treatment_break_date);
                        const scheduleRestartDate = moment(v, 'DD.MM.YYYY');
                        return (
                            scheduleRestartDate >= treatmentBreakDate ||
                            t('patients::validation.field.date_must_be_greater_than_treatment_break_date')
                        );
                    },
                ],
            },
        };
    },
    computed: {
        dispensing() {
            return this.$store.state.patients.patient.dispensing;
        },
        dispensingForm() {
            return this.$store.state.patients.dispensingForm;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        dispensingScheduleOptions() {
            const week = this.dispensing.schedule_frequency || 'weekly';
            return this.$store.state.patients.dispensingScheduleOptions.map((x) => {
                return {
                    text: (x.text = `${t('patients::schedule_frequency.' + week)} ${x.text}`),
                    value: x.value,
                };
            });
        },
    },
    created() {
        this.$store.dispatch('patients/loadDispensingScheduleOptions');
    },
    mounted() {
        this.setSelectedRestartPeriod();
    },
    methods: {
        setSelectedRestartPeriod() {
            let treatmentBreakDate = new Date(this.dispensing.treatment_break_date);
            let scheduleRestartDate = new Date(this.dispensingForm.event_date);

            let diffInTime = scheduleRestartDate.getTime() - treatmentBreakDate.getTime();
            let diffInDays = diffInTime / (1000 * 3600 * 24);

            let value = null;

            switch (true) {
                case diffInDays < 2:
                    value = 'less_than_48_hours';
                    break;
                case diffInDays < 3:
                    value = 'between_48_and_72_hours';
                    break;
                case diffInDays >= 3 && diffInDays < 28:
                    value = 'between_72_hours_and_4_weeks';
                    break;
                case diffInDays >= 28:
                    value = 'more_than_4_weeks';
                    break;
                default:
                    value = this.dispensing.treatment_break_period;
            }

            this.$store.dispatch('patients/updateProperty', {
                property: 'dispensingForm.schedule_restart_period',
                value: value,
            });
        },
        restartSchedule() {
            this.$store.dispatch('patients/setDispensingLoading', true);
            return axios
                .post(
                    route('api.v1.patients.dispensing-schedule-restarts.store', {
                        patient: this.patientId,
                    }),
                    {
                        schedule_restart_period: this.dispensingForm.schedule_restart_period,
                        event_date: this.dispensingForm.event_date,
                    }
                )
                .then(() => {
                    this.$store.dispatch('patients/resetDispensingForm');
                })
                .catch((error) => {
                    this.$store.dispatch('patients/setDispensingLoading', false);
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    // this.$store.dispatch('patients/setDispensingLoading', false);
                });
        },
    },
};
</script>
